export default __webpack_public_path__ + "static/media/PAFI_The Invitation of GMS 2023.fee3e5e3.pdf";